<div class="modal-backdrop" (click)="onClose()"></div>

<div class="upi-transfer-container" (click)="$event.stopPropagation()">

    <div class="card-stack" [class.compact-mode]="step() >= 2" [class.success-mode]="step() === 4">
        <!-- Header Card -->
        @if (step() !== 4) {
        <div class="upi-header-card">
            <div class="upi-header-content">
                <h2 class="title">
                    {{ step() === 1 ? 'To Own Account' : step() === 2 ? 'To Own Account' : 'Security' }}
                </h2>
            </div>

            <!-- Step Indicator -->
            @if (step() <= 2) { <div class="step-indicator-wrapper">
                <span class="step-label">Step {{ step() }} of 2</span>
                @if (step() === 1) {
                <img src="assets/icons/step-zero.svg" alt="step progress" class="step-progress-img">
                } @else {
                <div class="progress-container">
                    <div class="segment" [class.filled]="step() >= 1"></div>
                    <div class="segment" [class.filled]="step() > 2"></div>
                </div>
                }
        </div>
        }

        <!-- Final Label -->
        @if (step() === 3) {
        <div class="step-indicator-wrapper">
            <span class="step-label">Final</span>
            <div class="progress-container">
                <div class="segment filled"></div>
                <div class="segment filled"></div>
            </div>
        </div>
        }
        @if (step() !== 3) {
        <div class="close-action-wrapper" (click)="onClose()">
            <div class="close-icon-container">
                <img src="assets/icons/close-48.png" alt="close">
            </div>
        </div>
        }
    </div>
    }

    <!-- Body Card -->
    <div class="upi-body-card" [class.success-body]="step() === 4">
        <form class="upi-body-inner" [class.no-padding]="step() === 4" [formGroup]="form"
            (submit)="$event.preventDefault()">

            <!-- Step 1: Amount & Transfer Selection -->
            @if (step() === 1) {
            <div class="step-main-heading">Amount</div>

            <div class="amount-transfer-container">
                <!-- Amount Display -->
                <div class="amount-display">
                    <div class="value-wrapper">
                        <div class="inner-row">
                            <input type="text" formControlName="amount" class="amount-val" placeholder="0.00">
                            <div class="currency">INR</div>
                        </div>
                    </div>

                    <div class="balance-info">
                        <div class="label-grp">
                            <span>Available</span>
                            <span>{{ formattedAvailable() }}</span>
                        </div>
                        <div class="max-btn" (click)="setMaxAmount()">MAX</div>
                    </div>
                </div>

                <!-- From / To Selection -->
                <div class="from-to-section" (click)="closeDropdowns()">
                    <div class="label-from">From</div>
                    <div class="label-to">To</div>

                    <!-- From Card -->
                    <div class="card-selector pos-from" (click)="toggleFromDropdown($event)">
                        <div class="card-info">
                            <div class="c-name">{{ selectedSource().name }}</div>
                            <div class="c-num">{{ selectedSource().number }}</div>
                        </div>
                        <div class="change-badge">
                            <div class="txt">Change</div>
                            <div class="arrow-icon">
                                <img src="assets/icons/direction-down20x20.svg" alt="v">
                            </div>
                        </div>
                        <!-- Dropdown List -->
                        @if (isFromDropdownOpen()) {
                        <div class="account-dropdown-list" (click)="$event.stopPropagation()">
                            @for (acc of accounts; track acc.id) {
                            <div class="dropdown-item" (click)="selectSource(acc, $event)">
                                <div class="d-name">{{ acc.name }}</div>
                                <div class="d-num">{{ acc.number }}</div>
                            </div>
                            }
                        </div>
                        }
                    </div>

                    <!-- Swap Icon -->
                    <div class="swap-icon-container" (click)="swapAccounts()">
                        <img src="assets/icons/img_arrow-sort.svg" alt="swap" style="width: 20px; height: 20px;">
                    </div>

                    <!-- To Card -->
                    <div class="card-selector pos-to" (click)="toggleToDropdown($event)">
                        <div class="card-info">
                            <div class="c-name">{{ selectedDestination().name }}</div>
                            <div class="c-num">{{ selectedDestination().number }}</div>
                        </div>
                        <div class="change-badge">
                            <div class="txt">Change</div>
                            <div class="arrow-icon">
                                <img src="assets/icons/direction-down20x20.svg" alt="v">
                            </div>
                        </div>
                        <!-- Dropdown List -->
                        @if (isToDropdownOpen()) {
                        <div class="account-dropdown-list" (click)="$event.stopPropagation()">
                            @for (acc of accounts; track acc.id) {
                            <div class="dropdown-item" (click)="selectDestination(acc, $event)">
                                <div class="d-name">{{ acc.name }}</div>
                                <div class="d-num">{{ acc.number }}</div>
                            </div>
                            }
                        </div>
                        }
                    </div>
                </div>
            </div>
            }

            <!-- Step 2: Review -->
            @if (step() === 2) {
            <div class="review-list">
                <div class="review-item-row">
                    <div class="label">Card</div>
                    <div class="value">{{ selectedDestination().number }}</div>
                </div>
                <div class="row-divider"></div>
                <div class="review-item-row">
                    <div class="label">Amount</div>
                    <div class="value">₹{{ finalAmount() }}</div>
                </div>
                <div class="row-divider"></div>
                <div class="review-item-row">
                    <div class="label">Fee</div>
                    <div class="value">₹{{ fee() }}</div>
                </div>
            </div>
            }

            <!-- Step 3: Security -->
            @if (step() === 3) {
            <div class="row-divider" style="margin: 0 -12px; width: calc(100% + 24px);"></div>
            <div class="pin-grid-container">
                <div class="pin-label">UPI PIN or OTP</div>
                <div class="pin-groups-wrapper">
                    <div class="pin-group">
                        @for (control of pinControls.slice(0, 3); track $index) {
                        <div class="pin-box" [class.filled]="control.value">
                            <input #pinInput type="password" maxlength="1" [formControl]="$any(control)"
                                (input)="onPinInput($index, $event)"
                                (keydown.backspace)="onPinBackspace($index, $event)" autocomplete="one-time-code"
                                inputmode="numeric">
                            @if (control.value) {
                            <div class="filled-dot"></div>
                            }
                        </div>
                        }
                    </div>
                    <div class="pin-group">
                        @for (control of pinControls.slice(3, 6); track $index) {
                        <div class="pin-box" [class.filled]="control.value">
                            <input #pinInput type="password" maxlength="1" [formControl]="$any(pinControls[$index + 3])"
                                (input)="onPinInput($index + 3, $event)"
                                (keydown.backspace)="onPinBackspace($index + 3, $event)" autocomplete="one-time-code"
                                inputmode="numeric">
                            @if (control.value) {
                            <div class="filled-dot"></div>
                            }
                        </div>
                        }
                    </div>
                </div>
                @if (isFieldInvalid('pin')) {
                <div class="error-message">
                    Please enter a complete 6-digit PIN.
                </div>
                }
                @if (apiError()) {
                <div class="error-message">
                    {{ apiError() }}
                </div>
                }
            </div>
            <!-- Actions inside card for Step 3 -->
            <div class="step-inner-actions">
                <button type="button" class="btn-base btn-cancel-security" (click)="prevStep()">
                    Cancel
                </button>
                <button type="button" class="btn-base btn-primary-action" (click)="nextStep()">
                    Confirm
                </button>
            </div>
            }

            <!-- Step 4: Processing & Success -->
            @if (step() === 4) {
            <div class="success-content-wrapper">
                <!-- PROCESSING -->
                @if (isProcessing()) {
                <div class="success-header-section">
                    <div class="processing-loader-wrapper">
                        <div class="overlap-group">
                            <div class="footer-icon-wrapper">
                                <img class="huge-icon-interface spin-anim" src="assets/icons/img_loading.svg"
                                    alt="Loading" />
                            </div>
                            <div class="rectangle"></div>
                            <div class="blur-circle"></div>
                        </div>
                    </div>
                    <div class="success-title-main">Transactions Progress</div>
                    <div class="success-amount-main">₹{{ finalAmount() }}</div>
                </div>
                }

                <!-- SUCCESS -->
                @if (!isProcessing()) {
                <div class="success-header-section">
                    <div class="overlap-group">
                        <img class="huge-icon-interface" src="assets/icons/Frame 1996664347.png" alt="Success" />
                    </div>
                    <div class="success-title-main">Successfully!</div>
                    <div class="success-amount-main">₹{{ finalAmount() }}</div>
                </div>
                }

                <!-- Details (Shared) -->
                <div class="success-details-wrapper">
                    <div class="compact-review-card">
                        <div class="review-item-row">
                            <div class="label s5-label">Card</div>
                            <div class="value s5-value">{{ selectedDestination().number }}</div>
                        </div>
                        <div class="row-divider s5-divider"></div>
                        <div class="review-item-row">
                            <div class="label s5-label">Amount</div>
                            <div class="value s5-value">₹{{ finalAmount() }}</div>
                        </div>
                        <div class="row-divider s5-divider"></div>
                        <div class="review-item-row">
                            <div class="label s5-label">Fee</div>
                            <div class="value s5-value">₹{{ fee() }}</div>
                        </div>
                        <div class="row-divider s5-divider"></div>
                        <div class="review-item-row">
                            <div class="label s5-label">Recipient Name</div>
                            <div class="value s5-value">Rahul Sharma</div>
                        </div>
                    </div>
                </div>

                <!-- Done button -->
                <div class="step-inner-actions success-actions">
                    <button type="button" class="btn-base btn-primary-action btn-done"
                        [class.processing-btn]="isProcessing()" (click)="!isProcessing() && confirmCancel()">
                        Done
                    </button>
                </div>
            </div>
            }

        </form>
    </div>
</div>

<!-- Footer Section (Steps 1-2 only) -->
@if (step() <= 2) { <div class="upi-modal-footer">
    <button type="button" class="btn-base btn-back-action" (click)="step() === 1 ? onClose() : prevStep()">
        Back
    </button>
    <button type="button" class="btn-base btn-primary-action" (click)="nextStep()"
        [disabled]="!canProceedStep1Signal() && step() === 1">
        @if (step() === 1) { <span>Next</span> }
        @if (step() === 2) { <span>Send</span> }
    </button>
    </div>
    }
    </div>

    <!-- Cancel Confirmation Overlay -->
    @if (showCancelConfirm()) {
    <div class="cancel-confirm-overlay" (click)="$event.stopPropagation()" role="dialog" aria-modal="true">
        <div class="cancel-confirm-card">
            <div class="confirm-backdrop" (click)="closeCancelConfirm()"></div>
            <div class="cancel-modal">
                <div class="cancel-icon-ring">
                    <div class="icon-ring-bg danger">
                        <!-- Figma effect white shadow -->
                        <div class="cancel-main-icon-effect"
                            style="width: 75%; height: 75%; box-shadow: 4.444444179534912px 4.444444179534912px 4.444444179534912px; border-radius: 55.56px; border: 4px white solid; filter: blur(2.22px); position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                        </div>
                        <img src="assets/icons/img_combo-shape.svg" alt="cancel" class="cancel-main-icon">
                    </div>
                </div>
                <!-- Content -->
                <div class="confirm-content">
                    <div class="confirm-title">Cancel changes?</div>
                    <div class="confirm-subtext">All data will be erased irrevocably.</div>
                </div>
                <!-- Action Buttons -->
                <div class="confirm-actions">
                    <button type="button" class="btn-base btn-close-confirm" (click)="closeCancelConfirm()">
                        Close
                    </button>
                    <button type="button" class="btn-base btn-confirm btn-primary" (click)="confirmCancel()">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
    }